import { defineMessages } from "react-intl"

export default defineMessages({
  heading: {
    id: "app.components.Survey.heading",
  },
  surveyExpired: {
    id: "app.components.Survey.surveyExpired",
  },
  surveyAnswered: {
    id: "app.components.Survey.surveyAnswered",
  },
  surveyNotSelected: {
    id: "app.components.Survey.surveyNotSelected",
  },
  surveyNotFound: {
    id: "app.components.Survey.surveyNotFound",
  },
  surveySuccessHeader: {
    id: "app.components.Survey.surveySuccessHeader",
  },
  surveySuccessBody: {
    id: "app.components.Survey.surveySuccessBody",
  },
  goHome: {
    id: "app.components.Survey.goHome",
  },
  sendSurveyFail: {
    id: "app.components.Survey.sendSurveyFail",
  },
  submit: {
    id: "app.components.Survey.submit",
  },
  headerPlaytestAvailabilities: {
    id: "app.components.Survey.headerPlaytestAvailabilities",
  },
  sessionAvailabilities: {
    id: "app.components.Survey.sessionAvailabilities",
  },
  to: {
    id: "app.components.Survey.to",
  },
  notAvailable: {
    id: "app.components.Survey.notAvailable",
  },
  headerAdditionalInfo: {
    id: "app.components.Survey.headerAdditionalInfo",
  },
  pleaseSelectText: {
    id: "app.components.Survey.pleaseSelectText",
  },
  descriptionGamesPlayed: {
    id: "app.components.Survey.descriptionGamesPlayed",
  },
  havePlayed: {
    id: "app.components.Survey.havePlayed",
  },
  fieldRequired: {
    id: "app.site.required"
  },
  headerAdditionalPlaystestQuestions: {
    id: "app.components.Survey.headerAdditionalPlaytestQuestions"
  },
  headerUpdateGameExp: {
    id: "app.components.Survey.headerUpdateGameExp"
  },
  descriptionGameExp: {
    id: "app.components.Survey.descriptionGameExp"
  },
})
